/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  FooterService,
  IFooterMethods,
  FeatureSectionService,
  IFeatureSectionMethods,
  StaticPageContentService,
  IStaticPageContentMethods,
  UpdateKycService,
  IUpdateKycMethods,
  UpdatePaymentService,
  IUpdatePaymentMethods,
  IFormatPolicyDetailMethods,
  FormatPolicyDetailService,
  IFormatTimelineDetailMethods,
  FormatTimelineDetailService,
  ICancelPolicyMethods,
  CancelPolicyService,
  IGetTransactionListMethods,
  GetTransactionListService
} from "./components";

export type ProvisionalDetailAgent = IHeaderMethods &
  IFeatureSectionMethods &
  IFooterMethods &
  IStaticPageContentMethods &
  IUpdateKycMethods &
  IUpdatePaymentMethods &
  IFormatPolicyDetailMethods &
  IFormatTimelineDetailMethods &
  ICancelPolicyMethods &
  IGetTransactionListMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new FeatureSectionService(),
    new FooterService(),
    new StaticPageContentService(),
    new UpdateKycService(),
    new UpdatePaymentService(),
    new FormatPolicyDetailService(),
    new FormatTimelineDetailService(),
    new CancelPolicyService(),
    new GetTransactionListService(),
  ];
};

export const getAgent = () => {
  return createAgent<ProvisionalDetailAgent>({
    plugins: getPlugins(),
  });
};
